import React from 'react'

class CardGroup extends React.Component{
    render(){
        return(
            <div className="card md-3">
                <h5 className="card p-2">{this.props.title}</h5>
                <div className="card-body">
                    {this.props.children}
                </div>
             </div>

        )
    }
}
export default CardGroup;